import { AxiosInstance } from 'axios';
import { AxiosClient, AxiosUtils } from 'api/AxiosClient/AxiosClient';
import { config } from 'config';
import { PublicationOption } from 'types';
import { defaultPublicationOption, securitelOption } from './DefaultPublicationOption';
import * as Sentry from '@sentry/react';

class Offers {
  private readonly client: AxiosInstance;

  constructor() {
    this.client = AxiosClient.get({
      baseURL: config.URL_OFFERS,
    });
  }

  public async getOffers(price: number, nbStrengths: number): Promise<PublicationOption[]> {
    return this.client
      .get<any>('v1/classified/offers', {
        headers: AxiosClient.getAuthorizationHeader(),
        params: {
          price,
          family: 'AUTO',
          nbStrengths: nbStrengths,
        },
      })
      .then(r => {
        const publicationOptions: PublicationOption[] = r.data.options;

        const newPublicationOptions: PublicationOption[] = publicationOptions.map(option => {
          const defaultOpt = defaultPublicationOption.find(d => d.template === option.template);
          return { ...defaultOpt, ...option };
        });

        newPublicationOptions.push(securitelOption);
        return newPublicationOptions.sort((a, b) => (a.order ?? 0) - (b.order ?? 1));
      })
      .catch(r => {
        Sentry.captureException(r, {
          tags: {
            api: 'offers',
            endpoint: 'v1/classified/offers',
            ...AxiosUtils.enrichTags(r),
          },
        });
        return Promise.reject(r);
      });
  }
}

export const OffersService = new Offers();
